import { useState } from "react";

import { toast } from "sonner";

import { CreateWorkspaceForm as CreateWorkspaceForm } from "@/components/pieces/create-workspace/CreateWorkspaceForm";
import {
  getJwtToken,
  getRefreshToken,
  setTokens,
} from "@/components/session/JwtTokenManager";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogInner,
  DialogTitle,
} from "@/components/ui/dialog";
import { useAssignInitialWorkspaceAdminMutation } from "@/graphql";

interface CreateWorkspaceDialogProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

export function CreateWorkspaceDialog({
  visible = false,
  setVisible,
}: CreateWorkspaceDialogProps) {
  const [errorText, setErrorText] = useState<string>();
  const [mutate, { loading }] = useAssignInitialWorkspaceAdminMutation({
    onCompleted: (data) => {
      setVisible(false);
      const urlSlug = data.assignInitialWorkspaceAdmin?.urlSlug;
      if (urlSlug) {
        if (USE_SUBDOMAINS) {
          window.location.href = `/to-workspace/${urlSlug}`;
        } else {
          setTokens({
            token: getJwtToken(),
            refreshToken: getRefreshToken(),
            workspaceSlug: urlSlug,
            success: () => {
              window.location.href = "/dashboard";
            },
            error: () => {
              toast.error("Failed to switch workspace");
            },
          });
        }
      }
    },
    onError: () => {
      setErrorText(
        "We ran into a technical issue while finalizing your workspace setup. Please contact support.",
      );
    },
  });

  const assignInitialWorkspaceAdminApiCall = (token?: string) => {
    if (!token) return;
    mutate({
      variables: {
        workspaceSignedToken: token,
      },
    });
  };

  const onSlugChange = () => {
    setErrorText(undefined);
  };

  return (
    <Dialog open={visible} onOpenChange={setVisible}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create Workspace</DialogTitle>
        </DialogHeader>
        <DialogInner>
          <CreateWorkspaceForm
            errorText={errorText}
            loading={loading}
            redirectToSignup={false}
            onSlugChange={onSlugChange}
            onCreateWorkspaceComplete={assignInitialWorkspaceAdminApiCall}
          />
        </DialogInner>
      </DialogContent>
    </Dialog>
  );
}
